import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HttpService } from '../../shared/services/http.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/modules/userModule/shared/user.service';
import { FormControl, Validators } from '@angular/forms';
import { Asset } from 'src/app/models/asset';
import { AssetFileSpecification } from 'src/app/models/assetFileSpecification';
import { AssetFile } from 'src/app/models/assetFile';
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { User } from 'src/app/models/user';
import { AssetAttributes } from 'src/app/models/assetAttributes';
import { ContactInfo } from 'src/app/models/contactInfo';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Quality } from 'src/app/models/quality';
import { Observable } from 'rxjs';
import { ThreeAssetRenderComponent } from '../three-asset-render/three-asset-render.component';
import { ConfigService } from 'src/app/shared/services/config.service';
import { Location } from '@angular/common';

declare var MediaRecorder: any;

@Component({
  selector: 'app-upload-new-asset',
  templateUrl: './upload-new-asset.component.html',
  styleUrls: ['./upload-new-asset.component.css']
})

export class UploadNewAssetComponent implements OnInit {

  asset: Asset = new Asset();
  assetFileSpecifaction: AssetFileSpecification = new AssetFileSpecification();
  assetFile: AssetFile = new AssetFile();
  files: NgxFileDropEntry[] = [];
  texturesFiles: any[] = [];
  threeDfile: any;
  otherFiles: any[] = [];
  fileQuality = "High";
  texturequality = "High";
  loader = false;
  uploadPercentDone = 0;
  loggedInUser: User = new User();
  assetAttributes: AssetAttributes = new AssetAttributes();
  primaryContactInfo: ContactInfo = new ContactInfo();
  radioButtonValue: any;
  uploadWarningText = "Warning! Closing the browser will terminate the upload process";
  snapshotImages: Array<string> = [];
  uploadedFiles: Array<any> = [];
  myCreatedFiles: Array<any> = [];
  public threeFileTypes: string[];
  public textureFilesFormats: string[];
  public otherFilesFormats: string[];
  public readonly platforms: Array<string> = ["Windows", "MacOS", "iOS", "Android"];
  showPrimaryContactDiv = false;
  uploadProcess = false;
  noFilerError = false;
  currentFolderDetails: any;
  assetNameExists = false;
  assetTagError = false;

  unsupportedFiles = [];
  primaryContactNameControl = new FormControl('', [Validators.required]);
  primaryContactEmailControl = new FormControl('', [Validators.email, Validators.required, Validators.pattern('.*@siemens-healthineers.com')]);
  assetNameControl = new FormControl('', [Validators.required]);
  
  isUploadClicked = false;
  progressStep: number;
  viewAssetSpecification: string;
  assetTags: string;
  isPrimaryContact = true;
  assetDescriptionControl = new FormControl('', [Validators.required]);
  isNextClicked = false;
  initialUpload = false;
  disableStep1 = false;
  library: any;
  assetIdParms: string;
  width = innerWidth / 2 - 100;
  height = innerHeight / 2 + 300;
  seenBackGround = "black";
  tempImg = "";
  basicColours = ['black', 'white', 'grey', '#009999', '#EC6602'];
  previewImage: File[] = [];
  preview = [];
  supportedImageFormats = ['jpg', 'jpeg', 'png', 'tiff', 'gif', 'bmp'];
  assetTagsView: Array<string>;
  selectedPreviewImages: string[] = [];
  polygonCount: number;
  folderpath: string;
  isRemix = true;

  assetNameRegExp = new RegExp('^[a-zA-Z0-9-_ ]+$');
  assetNameValidFlg;

  @ViewChild('threeViewer') threeViewer: ThreeAssetRenderComponent;
  @ViewChild('input') input: ElementRef<HTMLInputElement>;
  @ViewChild('browseFile') browse: ElementRef;
  assetBundleFile: string;
  noPlatformSet: boolean = true;
  platformSelected: string;
  unsupportedImageErrorMessage: string = "";
  theme_color: string;
  canvasRecording: File;
  showSuccess: boolean;
  showSuccessMessage: any;
  disableRecord: boolean;
  rotation: boolean;

  applications: any = [];
  isAdminUser: boolean = false;

  constructor(public httpService: HttpService, private router: Router, private userService: UserService, private activatedRoute: ActivatedRoute,
    private config: ConfigService, private _location: Location) { }

  ngOnInit() {
    let User = JSON.parse(sessionStorage.getItem('userinfo'));
    this.theme_color = User.userSettings.userThemeType===0?'dark':'light';
    document.documentElement.setAttribute('theme',this.theme_color);
    this.config.searchActive = false;
    this.config.homeActive = false;
    this.config.personalBrowserActive = false;
    this.config.uploadAssetsActive = true;

    // Get FileFormats
    this.httpService.getFileFormats().then(response => {
      this.threeFileTypes = response.threedFilesFormats;
      this.textureFilesFormats = response.textureFilesFormats;
      this.otherFilesFormats = response.readmeFilesFormats;
    });
    
    this.httpService.currentSearchPath.subscribe(path => {
      this.folderpath = path;
    });
    if (!this.folderpath) {
      this.activatedRoute.params.subscribe(param => {
        this.folderpath = param.folder;
      });
    }
    this.progressStep = 1;
    this.httpService.clear3DCache = false;
    if (!this.httpService.folder) {
      // sessionStorage.clear();
      this.router.navigateByUrl("/val-assets/home");
      return;
    }
    this.asset = new Asset();
    this.asset.name = "";

    this.assetFileSpecifaction = new AssetFileSpecification();
    this.uploadPercentDone = 0;
    this.loggedInUser = this.userService.loggendInUser;
    if (this.loggedInUser.userEmailId == "") {
      this.loggedInUser = JSON.parse(sessionStorage.getItem("userinfo")) as User;
    }

    this.assetAttributes.uploader = this.loggedInUser.userEmailId;
    this.primaryContactInfo.emailId = this.loggedInUser.userEmailId;
    this.primaryContactInfo.name = this.loggedInUser.name;
    this.asset.attributes = this.assetAttributes;
    this.asset.attributes.primaryContact = this.primaryContactInfo;

    this.asset.attributes.productStatus = 0;
    this.asset.attributes.visibility = 0;
    this.getFolderDetails();

    this.primaryContactNameControl = new FormControl(this.asset.attributes.primaryContact.name, [Validators.required]);
    this.primaryContactEmailControl = new FormControl(this.asset.attributes.primaryContact.emailId, [Validators.email, Validators.required, Validators.pattern('.*@siemens-healthineers.com')]);
    if (this.httpService.newVersionFlag || this.httpService.newExtensionFlag || this.httpService.updateAssetFile) {
      this.assetNameControl = new FormControl(this.asset.name, [Validators.required]);
    }
    this.getRootFolder();

    this.checkIfUserIsAdmin();
    this.getExternalApplications();

    window.addEventListener('resize', () => {
      this.width = (innerWidth / 2) - 100;
      this.height = innerHeight / 2 + 300;
      if (this.threeViewer)
        this.threeViewer.onResize({ "width": this.width, "height": this.height });
    }, false);
  }

  canDeactivate(): Observable<boolean> | boolean {
    if (this.uploadProcess)
      return confirm("Want to navigate without Upload?");
    else return true;
  }

  dropAssetbundle(files: NgxFileDropEntry[]) {
    files.forEach(file => {
      if (this.validExtensionCheck(file.relativePath)) {
        this.threeDfile = file;
      }
      else if (this.otherFilesFormats.indexOf(file.relativePath.split('.')[file.relativePath.split('.').length - 1].toLowerCase()) > -1) {
        this.otherFiles.push(file);
      }
      else
        document.getElementById('assetbundle-warning').setAttribute('visible', 'true');
    });
    console.log(this.threeDfile, this.otherFiles);
  }

  validExtensionCheck(file): boolean {
    let extn = file.split('.');
    if (extn.length > 1) {
      return false;
    }
    return true;
  }

  remove() {
    this.assetBundleFile = null;
  }

  dropped(files: NgxFileDropEntry[]) {
    this.files = files;
    this.unsupportedFiles = [];
    let texturesFiles = [];
    let otherFiles = [];
    let duplicateFileName;
    //get all 3D files uploaded by the user
    let all3DFiles = files.filter(
      file => {
        if (this.threeFileTypes.indexOf(file.relativePath.split('.')[file.relativePath.split('.').length - 1].toLowerCase()) > -1) {
          return true;
        }
        else if (this.textureFilesFormats.indexOf(file.relativePath.split('.')[file.relativePath.split('.').length - 1].toLowerCase()) > -1) {
          texturesFiles.push(file);
          return false
        }
        else if (this.otherFilesFormats.indexOf(file.relativePath.split('.')[file.relativePath.split('.').length - 1].toLowerCase()) > -1) {
          if (this.otherFiles && this.otherFiles.length > 0) {
            duplicateFileName = this.otherFiles.filter(existingFile => existingFile.fileEntry.name == file.fileEntry.name)
          }
          otherFiles.push(file);
          return false
        }
        else {
          this.unsupportedFiles.push(`.${file.relativePath.split('.')[file.relativePath.split('.').length - 1]}`);
          return false;
        }
      }
    );

    this.unsupportedFiles = Array.from(new Set(this.unsupportedFiles));
    if (files.length > all3DFiles.length + texturesFiles.length + otherFiles.length) {
      texturesFiles = [];
      all3DFiles = new Array<NgxFileDropEntry>();
      document.getElementById('unsupported').setAttribute('visible', 'true');
    }

    if (this.texturesFiles.length === 0) {
      this.texturesFiles = texturesFiles;
    } else {
      this.texturesFiles = [...this.texturesFiles, ...texturesFiles];
    }

    if (all3DFiles.length === 1) {
      this.threeDfile = all3DFiles[0];
    }
    else if (all3DFiles.length > 1) {
      // alert("one 3d object per selection");
      document.getElementById('3D-file-warning').setAttribute('visible', 'true');
    }
    if (duplicateFileName && duplicateFileName.length > 0) {
      alert("Duplicate file names not allowed");
      otherFiles.pop();
    }
    if (this.otherFiles.length === 0) {
      this.otherFiles = otherFiles;
    } else {
      this.otherFiles = [...this.otherFiles, ...otherFiles];
    }

    if (null !== this.threeDfile) {
      var element = document.getElementById('dropFilesBox');
      if (element) {
        if (element.children && element.children[0]) {
          element.children[0].removeAttribute('style');
        } else {
          element.removeAttribute('style');
        }
      }
    }
  }

  fileOver(event) {
    console.log(event);
  }

  fileLeave(event) {
    console.log(event);
  }

  changeCheckBoxValue(obj, param) {
    setTimeout(() => {
      obj[param] = !obj[param];
    });
    // console.log(this.asset.attributes);
  }

  removeTag(tagIndex) {
    let indexToRemove = this.asset.tags.length == 1 ? tagIndex : this.asset.tags.length - tagIndex - 1;
    this.asset.tags.splice(indexToRemove, 1);
    this.assetTagsView = [...this.asset.tags].reverse();
  }

  validateTagName(tag: string) {
    this.assetTagError = false;
    if (tag && tag.trim().length >= 1) {
      let regex = new RegExp('^[.]{0,1}([a-z\\d ]+)[#]*([-.]?[a-z\\d ]+)*[#]*([+]{2}[a-z\\d ]+)*[#]*([+]{0,2})$');
      this.assetTagError = !regex.test(tag.toLowerCase().trim());
    }
    return this.assetTagError;
  }

  addTags(tag: string) {
    if (!this.validateTagName(tag)) {
      if (tag.length > 0)
        this.asset.tags.push(tag.toLowerCase());
    }
    this.assetTagsView = [...this.asset.tags].reverse();
  }

  upload() {
    // if (this.validateAssetForm()) {
    let quality: Quality = new Quality();
    this.assetFileSpecifaction.fileQuality = quality.quality[this.fileQuality];
    this.assetFileSpecifaction.textureQuality = quality.quality[this.texturequality];

    const formData = new FormData();
    if (this.initialUpload) {
      if (this.threeDfile.fileEntry && this.threeDfile.fileEntry.isFile) {
        const threeDfileEntry = this.threeDfile.fileEntry as FileSystemFileEntry;
        console.log(threeDfileEntry);

        threeDfileEntry.file((file: File) => {
          //access the real file
          this.uploadedFiles.push(file);
          // console.log(this.threeDfile.relativePath, file);
          console.log(this.uploadedFiles);
          let nameAttribute = this.asset.attributes.compatibilityWithUnity ? 'unitymodel' : 'threejsmodel';
          formData.append(nameAttribute, file, this.threeDfile.relativePath.split("/")[this.threeDfile.relativePath.split("/").length - 1]);
          this.assetFileSpecifaction.fileFormat = this.asset.attributes.compatibilityWithUnity ? "assetbundle" : this.threeDfile.relativePath.split('.')[this.threeDfile.relativePath.split('.').length - 1];
        });
      } else {
        // It was a directory (empty directories are added, otherwise only files)
        const fileEntry = this.threeDfile.fileEntry as FileSystemDirectoryEntry;
        // console.log(this.threeDfile.relativePath, fileEntry);
        this.uploadedFiles.push(this.threeDfile);
        console.log(this.uploadedFiles);
        let nameAttribute = this.asset.attributes.compatibilityWithUnity ? 'unitymodel' : 'threejsmodel';
        formData.append(nameAttribute, new Blob([this.threeDfile, this.texturesFiles, this.otherFiles]),
          this.threeDfile.name);
        if (this.threeDfile.name) {
          this.assetFileSpecifaction.fileFormat = this.asset.attributes.compatibilityWithUnity ? "assetbundle" : this.threeDfile.name.split('.')[this.threeDfile.name.split('.').length - 1];
        }
      }

      let textureFiles = [];
      this.texturesFiles.forEach(async textureFile => {
        if (textureFile.fileEntry && textureFile.fileEntry.isFile) {
          const texturefileEntry = textureFile.fileEntry as FileSystemFileEntry;
          texturefileEntry.file((file: File) => {
            let fileName = textureFile.relativePath.split("/")[textureFile.relativePath.split("/").length - 1];
            if((fileName.split(".")[1]).toLowerCase() === "mtl"){
              fileName = this.threeDfile.fileEntry.name.split(".")[0] + "." + fileName.split(".")[1];
            }
            if (textureFiles.indexOf(fileName) <= -1) {
              formData.append('texture', file, fileName);
              textureFiles.push(fileName)
            }
          });
        } else if (textureFile.name) {
          let fileName = textureFile.name;
          if((fileName.split(".")[1]).toLowerCase() === "mtl"){
            fileName = this.threeDfile.name.split(".")[0] + "." + textureFile.name.split(".")[1];
          }
          if (textureFiles.indexOf(fileName) <= -1) {
            formData.append('texture', textureFile, fileName);
            textureFiles.push(fileName);
          }

        } else {
          // It was a directory (empty directories are added, otherwise only files)
          const fileEntry = this.threeDfile.fileEntry as FileSystemDirectoryEntry;
          console.log(this.threeDfile.relativePath, fileEntry);
        }
      });

      let otherFiles = [];
      this.otherFiles.forEach(async otherFile => {
        if (otherFile.fileEntry && otherFile.fileEntry.isFile) {
          const otherFileEntry = otherFile.fileEntry as FileSystemFileEntry;
          otherFileEntry.file((file: File) => {
            let fileName = otherFile.relativePath.split("/")[otherFile.relativePath.split("/").length - 1];
            if (textureFiles.indexOf(fileName) <= -1) {
              formData.append('readme', file, fileName);
              otherFiles.push(fileName)
            }
          });
        } else if (otherFile.name || otherFile.relativePath) {

          let fileName = null === otherFile.name ? otherFile.relativePath : otherFile.name;
          if (textureFiles.indexOf(fileName) <= -1) {
            formData.append('readme', otherFile, fileName);
            otherFiles.push(fileName);
          }
        } else {
          // It was a directory (empty directories are added, otherwise only files)
          const fileEntry = this.threeDfile.fileEntry as FileSystemDirectoryEntry;
          console.log(this.threeDfile.relativePath, fileEntry);
        }
      });
    }

    setTimeout(() => {
      if (this.httpService.newExtensionFlag && this.asset.assetfiles.filter(assetFile => assetFile.specification.fileFormat.toLowerCase() === this.assetFileSpecifaction.fileFormat.toLowerCase()
        && assetFile.specification.textureQuality === this.assetFileSpecifaction.textureQuality
        && assetFile.specification.fileQuality === this.assetFileSpecifaction.fileQuality).length > 0) {
        document.getElementById('alreadyPresent').setAttribute('visible', 'true');
        return;
      }
      this.assetFileSpecifaction.fileType = '3D';

      this.assetFile.specification = this.assetFileSpecifaction;
      this.assetFile.platform = this.platformSelected;
      if (!this.asset.assetfiles) {
        this.asset.assetfiles = new Array<AssetFile>();
      }
      formData.append('flow', '0');
      if (this.initialUpload) {
        this.asset.assetfiles.push(this.assetFile);
      } else {
        this.asset.assetfiles[0].specification = this.assetFileSpecifaction;
      }
      delete this.asset.inform;
      // console.log(JSON.stringify(this.asset, null, 2));
      // console.log(formData);
      if (!this.initialUpload) {
        this.loader = true;
      }
      this.uploadProcess = true;
      if (this.initialUpload) { // Initial upload
        this.asset.isCompletelyUploaded = false;
        formData.append('assetinfo', JSON.stringify(this.asset));
        formData.append('parentfolderid', this.httpService.folder._id);
        let uploadProcess = false;

        console.log(formData.get("assetinfo"));

        this.httpService.uploadFile(`${this.httpService.basePath}/asset/upload/${this.loggedInUser.userEmailId}`, formData).subscribe(
          (data: any) => {
            if (data.type === HttpEventType.UploadProgress) {
              // This is an upload progress event. Compute and show the % done:
              const percentDone = Math.round(100 * data.loaded / data.total);
              this.uploadPercentDone = percentDone;
              console.log(data);
              console.log(`File is ${this.uploadPercentDone}% uploaded.`);
              if (this.uploadPercentDone >= 100) {
                console.log(data);
                this.uploadWarningText = "Preparing your Asset"
                uploadProcess = true;
              }
            } else if (event instanceof HttpResponse) {
              console.log('File is completely uploaded!');
              console.log(data);
              this.loader = false;
            } else {
              if (uploadProcess) {
                console.log('File is completely uploaded!');
                console.log(data);
                if (data.body) {
                  setTimeout(() => {
                    this.loader = false;
                    this.uploadProcess = false;
                    this.asset._id = data.body._id;
                    this.asset.relativePath = data.body.relativePath;
                    this.asset.attributes.creationDate = data.body.attributes.creationDate;
                    this.asset.attributes.maintainedUntil = data.body.attributes.maintainedUntil;
                    this.asset.attributes.lastUpdated = data.body.attributes.lastUpdated;
                    this.asset.ratings = data.body.ratings;
                    this.httpService.selectedAssetFile = data.body.assetfiles[0];
                    this.asset.assetfiles[0]._id = data.body.assetfiles[0]._id;
                    this.asset.assetfiles[0].filePath = data.body.assetfiles[0].filePath;
                    this.asset.assetfiles[0].versionNo = data.body.assetfiles[0].versionNo;
                    this.asset.assetfiles[0].platform = data.body.assetfiles[0].platform;
                    this.asset.remixedFrom = data.body.remixedFrom;
                    this.asset.remixes = data.body.remixes;
                    this.initialUpload = false;
                  }, 500);
                }
              }
            }
          }, err => {
            console.error(err);
            this.uploadProcess = false;
            this.loader = false;
            this.httpService.newExtensionFlag = false;
            this.httpService.newVersionFlag = false;
            this.httpService.updateAssetFile = false;
          }, () => {
            this.httpService.asset = null;
            this.resetData();
          }
        )
      }
      else {
        formData.append('parentfolderid', this.httpService.folder._id);
        this.asset.assetfiles[0] = this.httpService.selectedAssetFile;
        this.asset.assetfiles[0].specification.animation = this.assetFileSpecifaction.animation;
        this.asset.assetfiles[0].specification.rigged = this.assetFileSpecifaction.rigged;
        this.asset.assetfiles[0].specification.polygonCount = this.polygonCount;
        formData.append('assetinfo', JSON.stringify(this.asset));
        formData.append('snapshot', JSON.stringify(this.snapshotImages));

        if (this.previewImage && this.previewImage.length > 0) {
          for (let i = 0; i < this.previewImage.length; i++) {
            formData.append('previewImage', this.previewImage[i], this.previewImage[i].name);
          }
        }

        if(this.canvasRecording)
          {
            formData.append('previewImage',this.canvasRecording,this.canvasRecording.name);
          }
        this.httpService.uploadNewAssetFile(`${this.httpService.basePath}/asset/completeassetupload`, formData).subscribe(
          (data: any) => {

            this.loader = false;
            this.uploadProcess = false;
            this.httpService.previewDuringUpload = false;
            this.userService.loggendInUser.assetsUploaded.push(data._id);
            sessionStorage.setItem('userinfo', JSON.stringify(this.userService.loggendInUser));
            
            setTimeout(() => {
              this.router.navigateByUrl(`/val-assets/search/assets/${this.folderpath}/${this.asset._id}`);
            }, 1000);

          }, err => {
            console.error(err);
            this.uploadProcess = false;
            this.loader = false;
            this.resetData();
          }, () => {
            this.httpService.asset = null;
            this.resetData();
          }
        )
      }
    }, 500)
    // }
  }

  changeProductStatus() {
    this.radioButtonValue = 0;
    this.asset.attributes.productStatus = this.radioButtonValue;
  }

  validateAssetForm(): boolean {
    if (this.asset.name.length == 0) {
      this.assetNameControl.setValue(null);
      return false;
    }
    this.isUploadClicked = true;
    let isValid = true;
    this.assetNameExists = this.httpService.newVersionFlag || this.httpService.newExtensionFlag || this.httpService.updateAssetFile ? false : this.assetNameCheck(this.asset.name);
    isValid = !this.assetNameExists && this.assetNameControl.valid && this.primaryContactNameControl.valid && this.primaryContactEmailControl.valid && !this.assetTagError;
    if (!this.asset.attributes.primaryContact.name || this.asset.attributes.primaryContact.name.trim() === '') {
      isValid = false;
      this.primaryContactNameControl.setValue('');
    }
    if (!this.asset.attributes.primaryContact.emailId || this.asset.attributes.primaryContact.emailId.trim() === '') {
      isValid = false;
      this.primaryContactEmailControl.setValue('');
    }
    if (!this.threeDfile) {
      isValid = false;
      this.noFilerError = true;
      var element = document.getElementById('dropFilesBox');
      if (element) {
        if (element.children && element.children[0]) {
          element.children[0].setAttribute('style', 'border:1px dotted red!important');
        } else {
          element.setAttribute('style', 'border:1px dotted red!important');
        }
      }
    } else {
      this.noFilerError = false;
      var element = document.getElementById('dropFilesBox');
      if (element) {
        if (element.children && element.children[0]) {
          element.children[0].removeAttribute('style');
        } else {
          element.removeAttribute('style');
        }
      }
    }
    return isValid;
  }

  togglePCDiv(event) {
    setTimeout(() => {
      this.isPrimaryContact = !this.isPrimaryContact;
    });
    if (event.target.attributes.active) {
      this.showPrimaryContactDiv = true;
      this.asset.attributes.primaryContact.emailId = this.loggedInUser.userEmailId;
      this.primaryContactInfo.name = this.loggedInUser.name;
    } else {
      this.showPrimaryContactDiv = false;
      this.asset.attributes.primaryContact.name = this.loggedInUser.name;
      this.asset.attributes.primaryContact.emailId = this.loggedInUser.userEmailId;
    }
    this.primaryContactNameControl = new FormControl(this.asset.attributes.primaryContact.name, [Validators.required]);
    this.primaryContactEmailControl = new FormControl(this.asset.attributes.primaryContact.emailId, [Validators.email, Validators.required, Validators.pattern('.*@siemens-healthineers.com')]);
  }

  getFolderDetails() {
    if (this.httpService.folder) {
      if (!this.httpService.folder.assetList || this.httpService.folder.assetList.length === 0) {
        this.httpService.getFolderById(this.httpService.folder._id).subscribe(
          data => {
            this.currentFolderDetails = data;
          }
        );
      } else {
        this.currentFolderDetails = this.httpService.folder;
      }
    }
  }

  assetNameCheck(assetName: string): boolean {
    if (this.currentFolderDetails && this.currentFolderDetails.assetList) {
      if (this.currentFolderDetails.assetList.find(x => x.name.toLowerCase() === assetName.toLowerCase())) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  }

  fetchFileDetails() {
    this.httpService.fetchFiles(`${this.httpService.basePath}/asset/assetfiles/${this.asset._id}/${this.assetFile.versionNo}/${this.assetFile.specification.fileFormat}/${this.assetFile.specification.fileQuality}/${this.assetFile.specification.textureQuality}/${this.userService.loggendInUser.userEmailId}`)
      .subscribe(data => {
        data.forEach(file => {
          if (this.threeFileTypes.indexOf(file.split('.')[file.split('.').length - 1].toLowerCase()) > -1)
            this.threeDfile = new NgxFileDropEntry(file, null)
          else
            this.texturesFiles.push(new NgxFileDropEntry(file, null));
        });
      }, err => {
        console.error(err);
      });
  }

  deleteFile(file, deldeteFrom) {
    if (!this.httpService.updateAssetFile) {
      deldeteFrom.splice(deldeteFrom.indexOf(file), 1);
      return;
    }
    if (confirm("Are you sure you want to delete the file")) {
      this.httpService.deleteFile(`${this.httpService.basePath}/asset/assetfiles/${this.asset._id}/${this.assetFile.versionNo}/${this.assetFile.specification.fileFormat}/${this.assetFile.specification.fileQuality}/${this.assetFile.specification.textureQuality}/${file.relativePath}/${this.userService.loggendInUser.userEmailId}`).subscribe(
        data => {
          this.httpService.clear3DCache = true;
          deldeteFrom.splice(deldeteFrom.indexOf(file), 1);
        }, err => {
          console.error(err);
        }
      );
    }
  }

  deleteThreeDFile(file) {
    if (!this.httpService.updateAssetFile) {
      this.threeDfile = null;
      return;
    }
    if (confirm("Are you sure you want to delete the file")) {
      this.httpService.deleteFile(`${this.httpService.basePath}/asset/assetfiles/${this.asset._id}/${this.assetFile.versionNo}/${this.assetFile.specification.fileFormat}/${this.assetFile.specification.fileFormat}/${this.assetFile.specification.textureQuality}/${file.relativePath}/${this.userService.loggendInUser.userEmailId}`).subscribe(
        () => {
          this.httpService.clear3DCache = true;
          this.threeDfile = null;
        }, err => {
          console.error(err);
        }
      );
    }
  }

  resetData() {
    this.httpService.newExtensionFlag = false;
    this.httpService.newVersionFlag = false;
    this.httpService.updateAssetFile = false;
  }

  previousStep() {
    this.progressStep -= 1;
  }

  nextStep() {
    let isValid = true;
    this.isNextClicked = true;
    if (this.progressStep == 1) {
      if (this.asset.name.length == 0) {
        this.assetNameControl.setValue(null);
      }
      this.assetNameExists = this.httpService.newVersionFlag || this.httpService.newExtensionFlag || this.httpService.updateAssetFile ? false : this.assetNameCheck(this.asset.name);
      isValid = !this.assetNameExists && this.assetNameControl.valid && this.assetNameValidFlg;
      if (this.asset.attributes.compatibilityWithUnity && this.noPlatformSet) {
        isValid = false;
      }
      if (!this.threeDfile) {
        isValid = false;
        this.noFilerError = true;
        var element = document.getElementById('dropFilesBox');
        if (element) {
          if (element.children && element.children[0]) {
            element.children[0].setAttribute('style', 'border:1px dotted red!important');
          } else {
            element.setAttribute('style', 'border:1px dotted red!important');
          }
        }
      } else {
        this.noFilerError = false;

        let filesUpload = 0 === this.otherFiles.filter(f => f.name == "fileInfo.txt").length ? this.otherFiles.filter(f => f.relativePath == "fileInfo.txt") : this.otherFiles.filter(f => f.name == "fileInfo.txt");

        if (filesUpload.length === 0 && this.isRemix) {
          document.getElementById('remixes').setAttribute('visible', 'true');
          isValid = false;
        }

        var element = document.getElementById('dropFilesBox');
        if (element) {
          if (element.children && element.children[0]) {
            element.children[0].removeAttribute('style');
          } else {
            element.removeAttribute('style');
          }
        }
      }
      if (isValid) {
        if (!this.disableStep1) {
          this.initialUpload = true;
          this.disableStep1 = true;
          this.upload();
        }
      }
    } else if (this.progressStep == 2) {
      isValid = this.primaryContactNameControl.valid && this.primaryContactEmailControl.valid && !this.assetTagError;
      if (!this.asset.attributes.primaryContact.name || this.asset.attributes.primaryContact.name.trim() === '') {
        isValid = false;
        this.primaryContactNameControl.setValue('');
      }
      if (!this.asset.attributes.primaryContact.emailId || this.asset.attributes.primaryContact.emailId.trim() === '') {
        isValid = false;
        this.primaryContactEmailControl.setValue('');
      }
      if (!this.asset.description || this.asset.description.trim() === '') {
        isValid = false;
      }
      this.httpService.previewDuringUpload = true;
      if ((this.threeDfile.fileEntry ? this.threeDfile.fileEntry : this.threeDfile).name.split('.')[1] != 'obj') {
        if (this.texturesFiles.length > 0) {
          this.httpService.previewDuringUpload = false;
        }
      }
    } else if (this.progressStep == 3) {
    }

    if (isValid) {
      this.viewAssetSpecification = '';
      this.progressStep += 1;
      this.isNextClicked = false;
      if (this.assetFileSpecifaction) {
        Object.keys(this.assetFileSpecifaction).forEach(key => {
          this.viewAssetSpecification += this.assetFileSpecifaction[key] == true ? key + ', ' : '';
        });
      }
      this.assetTags = '';
      if (this.asset.tags) {
        this.asset.tags.forEach(tag => {
          this.assetTags += tag + ', ';
        });
      }
    }
  }

  folderselected(id) {
  }

  getRootFolder() {
    this.httpService.getRootFolderData(this.userService.loggendInUser.userEmailId).subscribe(
      data => {
        this.library = data;
      },
      error => {
        console.log(error);
      }
    );
  }

  selectBackground(event) {
    this.httpService.selectedAssetFile.previewBackgroudColor = event;
    this.tempImg = '';
    this.snapshotImages = [];
  }

  takeSnap() {
    this.tempImg = this.threeViewer.takeSnap();
    this.snapshotImages = [this.tempImg.split(',')[1]];
  }

  openBrowseWindow() {
    document.getElementById('browseFile').click();
  }

  selectPreviewImage(event) {
    //2097152
    //3145728

    let minWidth: number = 1280;
    let minHeight: number = 1024;
    let maxSize: number = 2097152;
    let previewImage: FileList = event.target.files;

    if (previewImage.length > 0 && previewImage.length <= 10) {
      if (this.selectedPreviewImages && this.selectedPreviewImages.length < 10) {
        for (let i = 0; i < previewImage.length; i++) {

          if (this.supportedImageFormats.indexOf(previewImage[i].name.split('.')[previewImage[i].name.split('.').length - 1].toLowerCase()) == -1
            || previewImage[i].size > maxSize) {
            document.getElementById('unsupported-image').setAttribute('visible', 'true');
            this.unsupportedImageErrorMessage = "Please upload image(less than 2MB) with image resolution of 1280 x 1024 px or higher.";
            return true;
          }
          let reader = new FileReader();

          reader.onload = (e: any) => {
            const img = new Image();
            img.src = e.target.result;
            img.onload = rs => {

              if (img.height < minHeight || img.width < minWidth) {
                //console.log(5, img_height + 'x' + img_width);
                this.unsupportedImageErrorMessage = "Please upload image(less than 2MB) with image resolution of 1280 x 1024 px or higher.";
                document.getElementById('unsupported-image').setAttribute('visible', 'true');
                return true;
              }
              else {
                this.selectedPreviewImages.push(e.target.result);
                this.previewImage.push(previewImage[i]);
              }

            }
          }
          reader.readAsDataURL(previewImage[i]);
        }

      }
    }
    else {
      document.getElementById('unsupported-image').setAttribute('visible', 'true');
      this.unsupportedImageErrorMessage = "Please upload upto 10 image(less than 2MB) only.";
    }

  }

  cancelUpload() {
    // if (confirm("Are you sure you want to cancel the upload process?")) {
      if (this.asset._id) {
        this.httpService.deleteAsset(this.asset._id, this.httpService.folder._id, this.userService.loggendInUser.userEmailId).subscribe(
          () => { }
        );
      }
      this.router.navigateByUrl('/val-assets/search');
    // }
  }

  getPolygonCount(event) {
    this.polygonCount = event;
  }
  /**
   * Method will be call once the browse button will be clicked.
   * @param event - Event on selecting any file through the browse button.
   */
  onFileSelected(event: any): void {
    if (this.asset.attributes.compatibilityWithUnity) {
      for (let i = 0; i < event.target.files.length; i++) {
        if (this.validExtensionCheck(event.target.files[i].name)) {
          this.threeDfile = event.target.files[i];
        }
        else if (this.otherFilesFormats.indexOf(event.target.files[i].name.split('.')[event.target.files[i].name.split('.').length - 1].toLowerCase()) > -1) {
          this.otherFiles.push(event.target.files[i]);
        }
        else
          document.getElementById('assetbundle-warning').setAttribute('visible', 'true');
      }
    }
    else
      this.getSelectedFolderDirectory(event);
  }

  /**
  * Function which will return the extension of the file after file has been browsed..
  * @param file - The file that is selected to upload
  */
  gettingExtensionOfFile(file) {
    const nameArray = file.name.split('.');
    const nameArrayLength = nameArray.length;
    const extension = (nameArray[nameArrayLength - 1]).toLowerCase();
    return extension;
  }

  onInputClick(event) {
    event.target.value = '';
  }
  /**
   * This method will be going to separate the files as 3d files and texture files or other files and generate the form data to upload the 3d model.
   */
  private getSelectedFolderDirectory(event: any): void {
    // this.input.nativeElement.value = '';
    const folderPaths: Array<any> = [];
    this.files = event.files;
    this.unsupportedFiles = [];
    let texturesFiles = [];
    let otherFiles = [];
    let all3DFiles = [];
    let extension = '';

    const filesArray = Object.values(event.target.files);
    // this.folderSelected.emit(folderPaths);
    all3DFiles = (filesArray.filter(file => this.threeFileTypes.indexOf(this.gettingExtensionOfFile(file)) > -1));
    texturesFiles = (filesArray.filter(file => this.textureFilesFormats.indexOf(this.gettingExtensionOfFile(file)) > -1));
    otherFiles = (filesArray.filter(file => this.otherFilesFormats.indexOf(this.gettingExtensionOfFile(file)) > -1));
    this.unsupportedFiles = (filesArray.filter(file =>
      (this.threeFileTypes.indexOf(this.gettingExtensionOfFile(file)) <= -1 ||
        this.textureFilesFormats.indexOf(this.gettingExtensionOfFile(file)) <= -1 ||
        this.otherFilesFormats.indexOf(this.gettingExtensionOfFile(file)) <= -1)));
    this.assignFiles(texturesFiles, all3DFiles, event, otherFiles);
  }

  getUnsupportedFilesExtensions(nsup: Array<any>): Array<string> {
    let unsupported: Array<string> = []
    nsup.forEach(item => {
      unsupported.push(`.${item.name.split('.')[item.name.split('.').length - 1]}`);
    });
    return unsupported;
  }

  assignFiles(texturesFiles, all3DFiles, event, otherFiles) {
    let allFileNamesinOther;
    let allFileNamesinOtherFiles;
    let duplicateFileName;
    this.unsupportedFiles = Array.from(new Set(this.unsupportedFiles));
    this.unsupportedFiles = this.getUnsupportedFilesExtensions(this.unsupportedFiles);
    if (event.target.files.length > all3DFiles.length + texturesFiles.length + otherFiles.length) {
      texturesFiles = [];
      all3DFiles = new Array<NgxFileDropEntry>();
      document.getElementById('unsupported').setAttribute('visible', 'true');
    }

    if (this.texturesFiles.length === 0) {
      this.texturesFiles = texturesFiles;
    } else {
      this.texturesFiles = [...this.texturesFiles, ...texturesFiles];
    }

    if (all3DFiles.length === 1) {
      this.threeDfile = all3DFiles[0];
    }
    else if (all3DFiles.length > 1) {
      // alert("one 3d object per selection");
      document.getElementById('3D-file-warning').setAttribute('visible', 'true');
    }

    if (this.otherFiles.length === 0) {
      this.otherFiles = otherFiles;
    } else {
      if (this.otherFiles && this.otherFiles.length > 0) {
        allFileNamesinOther = this.otherFiles.map(existingFile => existingFile.name);
        allFileNamesinOtherFiles = otherFiles.map(existingFile => existingFile.name);
        duplicateFileName = allFileNamesinOther.filter(file => allFileNamesinOtherFiles.includes(file));
        if (duplicateFileName && duplicateFileName.length > 0) {
          alert("Duplicate file names now allowed");
          otherFiles.pop();
        }
      }
      this.otherFiles = [...this.otherFiles, ...otherFiles];
    }

    if (null !== this.threeDfile) {
      var element = document.getElementById('dropFilesBox');
      if (element) {
        if (element.children && element.children[0]) {
          element.children[0].removeAttribute('style');
        } else {
          element.removeAttribute('style');
        }
      }
    }
  }

  /**
   * To validate the asset name
   * @param str - asset name 
   */
  assetNameValidation(str: string) {
    //The asset name must be alphanumeric with _ and - allowed.It should not end with _ and -
    if (this.assetNameRegExp.test(str) &&
      (!str.endsWith('-') && !str.endsWith('_')) &&
      (str.slice(0, 1) !== '_' && str.slice(0, 1) !== '-')) {
      this.assetNameValidFlg = true;
    } else {
      this.assetNameValidFlg = false;
    }
  }
  cancelUploadProcess() {
    document.querySelector('#demo-alert').setAttribute('visible', 'false');
    this._location.back()
  }
  notremixModal() {
    document.getElementById("remixes").removeAttribute("visible");
    this.isRemix = false;
    this.nextStep();
  }
  remixModal() {
    this.isRemix = true;
    document.getElementById("remixes").removeAttribute("visible");
  }

  recordCanvas(){
    this.startRecording();
  }

  startRecording() {
    this.disableRecord = true;
    this.rotation = true;
    this.takeSnap();
    const chunks = [];
    var canvas: HTMLCanvasElement = document.querySelector("canvas");
    const stream = (canvas as any).captureStream(60);
    var options = {mimeType: 'video/webm;codecs=vp9', bitsPerSecond: 1000000000};
    const rec = new MediaRecorder(stream,options); 
    rec.ondataavailable = e => chunks.push(e.data);
    rec.onstop = e => this.exportVid(new Blob(chunks, { type: 'video/webm'}));

    rec.start();
    setTimeout(() =>{ 
      rec.stop();
      this.successNotification("Recording Saved");
      this.disableRecord = false;
      this.rotation = false;
      this.nextStep();
    }, 5000);
    
  }

  exportVid(blob) {
    var file = new File([blob], this.asset.name+'.webm', { lastModified: new Date().getTime(), type: blob.type });
    this.canvasRecording = file;
  }

  successNotification(message) {
    this.showSuccess = true;
    this.showSuccessMessage = message;
    setTimeout(() => {
      this.showSuccess = false;
    }, 5000);
  }

  checkIfUserIsAdmin() {
    this.isAdminUser = false;
    this.userService.loggendInUser.applicationName.forEach((app) => {
      if (app.userGroup == 'Admin') {
        this.isAdminUser = true;
      }
    });
  }

  getExternalApplications() {
    this.userService.getExternalApplications().subscribe((res) => {
      this.applications = [];
      var userApps = JSON.parse(sessionStorage.userinfo).applicationName;
      var appIds = [];
      userApps.forEach(element => {
        appIds.push(element.application);
      });
      if (!this.isAdminUser) {
        res.forEach(element => {
          if (appIds.includes(element._id))
            this.applications.push(element);//to show only apps user have permission to
        });
      } else {
        this.applications = res;
        this.applications.forEach(element => {
          if (element.name == "VAL")
            element._id = "VAL Web App";
        });
      }
      sessionStorage.setItem("Applications", JSON.stringify(this.applications));
    });
  }

  updateApplicationId(appId){
    this.asset["applicationId"] = appId._id;
  }
}